export default __webpack_public_path__ + "static/media/sico_milkyway_radiotelescope.657fc4b8.jpg";